export default "__VITE_ASSET__Dyg8vfC8__"